// Lightweight client device signal (a weak ban fingerprint).
//
// NOTE: this file is deliberately NOT named "fingerprint.js" -- ad/tracker
// blockers block that exact filename by default, which 404s the module and blanks
// the app in dev. Do not rename it back. (Production builds are bundled into hashed
// chunks, so the name only matters in dev.)
//
// This is a minimal, dependency-free fingerprint for the MVP. Production should
// use a maintained library (FingerprintJS / ThumbmarkJS) for stability and
// server-side correlation (see docs/research/04-fingerprinting-bans.md). The
// fingerprint is only ever used as ONE weak signal in a layered ban decision;
// the authoritative IP is server-observed. ASCII only.

function canvasSignal() {
  try {
    const c = document.createElement('canvas');
    c.width = 240;
    c.height = 60;
    const ctx = c.getContext('2d');
    if (!ctx) return 'no-canvas';
    // The only deliberate non-ASCII in the source, and it must stay exactly as
    // it is. These two strings are drawn into the canvas whose pixels ARE the
    // device fingerprint, so changing a character -- including "tidying" the
    // emoji away -- changes every fingerprint this code has ever produced.
    // Every stored fp_key would stop matching, which would quietly un-ban
    // every banned device. Leave it alone.
    ctx.textBaseline = 'top';
    ctx.font = "16px 'Arial'";
    ctx.fillStyle = '#f60';
    ctx.fillRect(2, 2, 120, 24);
    ctx.fillStyle = '#069';
    ctx.fillText('Lumi ✨ fingerprint', 4, 6);
    ctx.fillStyle = 'rgba(102,204,0,0.7)';
    ctx.fillText('Lumi ✨ fingerprint', 6, 8);
    return c.toDataURL().slice(-96);
  } catch {
    return 'canvas-error';
  }
}

function djb2Hex(text) {
  let h = 5381;
  for (let i = 0; i < text.length; i += 1) h = ((h << 5) + h + text.charCodeAt(i)) >>> 0;
  return `fp${h.toString(16).padStart(8, '0')}`;
}

async function hashHex(text) {
  // Web Crypto (crypto.subtle) is only available in a SECURE CONTEXT (HTTPS or
  // localhost). Over http://<LAN-IP> it is undefined, so fall back to a simple
  // hash rather than throwing (which would otherwise blank the page).
  if (globalThis.crypto && crypto.subtle) {
    try {
      const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
      return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, '0')).join('');
    } catch {
      /* fall through to the simple hash */
    }
  }
  return djb2Hex(text);
}

let cached = null;

export async function getFingerprint() {
  if (cached) return cached;
  const signals = [
    navigator.userAgent,
    navigator.language,
    (navigator.languages || []).join(','),
    navigator.hardwareConcurrency,
    navigator.deviceMemory,
    navigator.platform,
    `${screen.width}x${screen.height}x${screen.colorDepth}`,
    new Date().getTimezoneOffset(),
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    canvasSignal(),
  ].join('|');
  cached = await hashHex(signals);
  return cached;
}
